export default __webpack_public_path__ + "static/media/Filter.d82f90fe.svg";